import { render, staticRenderFns } from "./oneExtantionPAnel.vue?vue&type=template&id=51208bb1&"
import script from "./oneExtantionPAnel.vue?vue&type=script&lang=js&"
export * from "./oneExtantionPAnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports